var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 25.5C25.1667 25.5 24.4583 25.2083 23.875 24.625C23.2917 24.0417 23 23.3333 23 22.5C23 21.6667 23.2917 20.9583 23.875 20.375C24.4583 19.7917 25.1667 19.5 26 19.5C26.8333 19.5 27.5417 19.7917 28.125 20.375C28.7083 20.9583 29 21.6667 29 22.5C29 23.3333 28.7083 24.0417 28.125 24.625C27.5417 25.2083 26.8333 25.5 26 25.5ZM19 28.5C18.45 28.5 17.9793 28.304 17.588 27.912C17.196 27.5207 17 27.05 17 26.5V18.5C17 17.95 17.196 17.4793 17.588 17.088C17.9793 16.696 18.45 16.5 19 16.5H33C33.55 16.5 34.021 16.696 34.413 17.088C34.8043 17.4793 35 17.95 35 18.5V26.5C35 27.05 34.8043 27.5207 34.413 27.912C34.021 28.304 33.55 28.5 33 28.5H19ZM21 26.5H31C31 25.95 31.1957 25.479 31.587 25.087C31.979 24.6957 32.45 24.5 33 24.5V20.5C32.45 20.5 31.979 20.304 31.587 19.912C31.1957 19.5207 31 19.05 31 18.5H21C21 19.05 20.804 19.5207 20.412 19.912C20.0207 20.304 19.55 20.5 19 20.5V24.5C19.55 24.5 20.0207 24.6957 20.412 25.087C20.804 25.479 21 25.95 21 26.5ZM15 32.5C14.45 32.5 13.9793 32.3043 13.588 31.913C13.196 31.521 13 31.05 13 30.5V20.5C13 20.2167 13.096 19.979 13.288 19.787C13.4793 19.5957 13.7167 19.5 14 19.5C14.2833 19.5 14.521 19.5957 14.713 19.787C14.9043 19.979 15 20.2167 15 20.5V30.5H31C31.2833 30.5 31.5207 30.596 31.712 30.788C31.904 30.9793 32 31.2167 32 31.5C32 31.7833 31.904 32.0207 31.712 32.212C31.5207 32.404 31.2833 32.5 31 32.5H15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.9c8eed9cfecaf82ea7478b8f12354bc7.svg";
export { ForwardRef as ReactComponent };